<app-accordion-help [helps]="helps"></app-accordion-help>



<ng-container *ngIf="is_loading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>

<br>
<mat-form-field class="mat-select-width">
  <mat-label>Report Type</mat-label>
  <mat-select (selectionChange)="selectEventReport($event)" class="dude.mat-select-value"  [disabled]="is_running===true" >
    <mat-option *ngFor="let dt of report_type_list" [value]="dt.id">
      {{dt.name}}
    </mat-option>
  </mat-select>
</mat-form-field>
<br>




<ng-container *ngIf="report_type">

  <section *ngIf="report_type=='attribution_first_click_ad_spend' || report_type=='attribution_last_click_ad_spend'" class="example-section" style="margin-top: 20px; margin-left: 20px">
    <label id="example-radio-group-label">Select Network</label>
    <mat-radio-group
      aria-labelledby="example-radio-group-label"
      class="example-radio-group"
      [(ngModel)]="adspendRadioNetworkValue" [disabled]="is_running===true">
      <mat-radio-button class="example-radio-button" *ngFor="let season of seasons" [value]="season">
        {{season}}
      </mat-radio-button>
    </mat-radio-group>
  </section>


  <section *ngIf="report_type=='attribution_first_click'" class="example-section" style="margin-top: 20px; margin-left: 20px">
  <span class="example-list-section">
    <mat-checkbox class="example-margin"
                  [checked]="allComplete"
                  [color]="task.color"
                  [indeterminate]="someComplete()"
                  (change)="setAll($event.checked)" [disabled]="is_running===true">
      {{task.name}}
    </mat-checkbox>
  </span>
    <span class="example-list-section">
    <ul>
      <li *ngFor="let subtask of task.subtasks">
        <mat-checkbox [(ngModel)]="subtask.completed"
                      [color]="subtask.color"
                      (ngModelChange)="updateAllComplete()" [disabled]="is_running===true">
          {{subtask.name}}
        </mat-checkbox>
      </li>
    </ul>
  </span>
  </section>

<div style="margin-top: 20px; margin-left: 20px">
  <form [formGroup]="myForm" (ngSubmit)="onSubmit()" autocomplete="off" novalidate>
    <mat-form-field>
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker" [disabled]="is_running===true">
        <input matStartDate placeholder="Start date" (dateChange)="addDateEvent('start', $event)"
               formControlName="start_date">
        <input matEndDate placeholder="End date" (dateChange)="addDateEvent('end', $event)"
               formControlName="end_date">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <br>

    <div class="flex-container-submit">
    <button mat-raised-button color="primary" [disabled]="!myForm.valid || is_running===true" type="submit">Submit</button>
    <button mat-raised-button type="button" color="primary" *ngIf="is_running" (click)="stopRunning()" style="margin-left: 10px">Cancel</button>
    </div>
  </form>


</div>
</ng-container>  <!--end report type-->

<br>

<ng-container *ngIf="is_data">
  <div style="margin-left: 20px" class="warn-icon-primary">
    <br>
    <label>No data for the selected time period</label>
  </div>
</ng-container>

<ng-container *ngIf="is_running===true">
  <div style="margin-left: 20px" class="warn-icon-primary">
    <br>
    <label>Depending on amount of traffic you get and the size of the date range; results can take 1-2 minutes</label>
  </div>
</ng-container>


<div [hidden]="report_list.length==0">

  <ng-container *ngIf="report_type=='attribution_first_click'">
    <app-include-first-click [data]="first_click_data"></app-include-first-click>
  </ng-container>


  <ng-container *ngIf="report_type=='attribution_first_click_ad_spend' || report_type=='attribution_last_click_ad_spend'">
    <div style="margin-left: 20px; width: 800px;">
      <br>
      <mat-form-field appearance="standard">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
      </mat-form-field>

      <div ngClass="table-width" ngClass.xs="table-width-xs" ngClass.sm="table-width-sm">
        <mat-card class="mat-elevation-z24">
          <mat-card-content>

            <div class="example-container mat-elevation-z24">
              <table mat-table [dataSource]="dataSourceFirstClickSales" matSort>

                <!-- Campaign Name Column -->
                <ng-container matColumnDef="campaign_name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Campaign Name</th>
                  <td mat-cell *matCellDef="let row"> {{row.campaign_name}} </td>
                </ng-container>

                <!-- Adgroup Name Column -->
                <ng-container matColumnDef="adgroup_name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Adgroup Name</th>
                  <td mat-cell *matCellDef="let row"> {{row.adgroup_name}} </td>
                </ng-container>

                <!-- Impressions Column -->
                <ng-container  matColumnDef="impressions">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Impressions</th>
                  <td mat-cell *matCellDef="let row"> {{row.impressions}} </td>
                </ng-container>

                <!-- Clicks Column -->
                <ng-container  matColumnDef="clicks">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Clicks</th>
                  <td mat-cell *matCellDef="let row"> {{row.clicks}} </td>
                </ng-container>

                <!-- Spend Column -->
                <ng-container  matColumnDef="spend">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Ad Spend</th>
                  <td mat-cell *matCellDef="let row"> {{row.spend | currency}} </td>
                </ng-container>


                <!-- Amount Column -->
                <ng-container  matColumnDef="amount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Sales</th>
                  <td mat-cell *matCellDef="let row"> {{row.amount | currency}} </td>
                </ng-container>

                <!-- Count Column -->
                <ng-container  matColumnDef="count">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Number of Sales</th>
                  <td mat-cell *matCellDef="let row"> {{row.count}} </td>
                </ng-container>

                <!-- CPS Column -->
                <ng-container  matColumnDef="cps">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Cost Per Sale</th>
                  <td mat-cell *matCellDef="let row"> {{row.cps | number : '1.2-2'}} </td>
                </ng-container>

                <!-- Star Column -->
                <ng-container matColumnDef="star" stickyEnd>
                  <th mat-header-cell [hidden]="is_table_column_hidden" *matHeaderCellDef></th>
                  <td mat-cell [hidden]="is_table_column_hidden" *matCellDef="let element">
                    <mat-icon>more_vert</mat-icon>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsFirstClickSales"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsFirstClickSales;" class="element-row"
                    (click)="getTableRecord(row)"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
                </tr>
              </table>

            </div>

            <div class="example-container">
              <mat-paginator [pageSize]="10"
                             [pageSizeOptions]="[5, 10, 25, 100]"
                             showFirstLastButtons></mat-paginator>
            </div>


          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </ng-container>  <!-- end  report_type=attribution_first_click_ad_sales-->



    <ng-container *ngIf="report_type=='attribution_first_click1111111'">
    <div style="margin-left: 20px; width: 800px;">
      <br>
      <mat-form-field appearance="standard">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
      </mat-form-field>

      <div ngClass="table-width" ngClass.xs="table-width-xs" ngClass.sm="table-width-sm">
        <mat-card class="mat-elevation-z24">
          <mat-card-content>

            <div class="example-container mat-elevation-z24">
              <table mat-table [dataSource]="dataSource" matSort>

                <!-- Pruchase DTColumn -->
                <ng-container matColumnDef="purchase_dt" sticky>
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                  <td mat-cell *matCellDef="let row"> {{row.purchase_dt}} </td>
                </ng-container>

                <!-- Service Column -->
                <ng-container matColumnDef="service" sticky>
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Service</th>
                  <td mat-cell *matCellDef="let row"> {{row.service}} </td>
                </ng-container>


                <!-- Amount Column -->
                <ng-container  matColumnDef="amount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Price</th>
                  <td mat-cell *matCellDef="let row"> {{row.amount | currency}} </td>
                </ng-container>

                <!--description-->
                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Name</th>
                  <td mat-cell *matCellDef="let row"> {{row.description}} </td>
                </ng-container>

                <!--fullName-->
                <ng-container matColumnDef="fullName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Lead Name</th>
                  <td mat-cell *matCellDef="let row"> {{row.fullName}} </td>
                </ng-container>

                <!--emailAddress-->
                <ng-container matColumnDef="emailAddress">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                  <td mat-cell *matCellDef="let row"> {{row.emailAddress}} </td>
                </ng-container>

                <!--phoneNumberStandard-->
                <ng-container matColumnDef="phoneNumberStandard">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone Number</th>
                  <td mat-cell *matCellDef="let row"> {{row.phoneNumberStandard}} </td>
                </ng-container>

                <!-- first_event_dt Column -->
                <ng-container matColumnDef="first_event_dt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>First Source Date</th>
                  <td mat-cell *matCellDef="let row"> {{row.first_event_dt}} </td>
                </ng-container>


                <!--first_action_id-->
                <ng-container matColumnDef="first_action_id">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>First Click Source</th>
                  <td mat-cell *matCellDef="let row"> {{row.first_action_id}}  </td>
                </ng-container>

                <!--first_provider-->
                <ng-container matColumnDef="first_provider">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>First Provider</th>
                  <td mat-cell *matCellDef="let row"> {{row.first_provider}}  </td>
                </ng-container>

                <!--first_adgroup-->
                <ng-container matColumnDef="first_adgroup">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>First Source</th>
                  <td mat-cell *matCellDef="let row"> {{row.first_adgroup}}  </td>
                </ng-container>

                <!-- Star Column -->
                <ng-container matColumnDef="star" stickyEnd>
                  <th mat-header-cell [hidden]="is_table_column_hidden" *matHeaderCellDef></th>
                  <td mat-cell [hidden]="is_table_column_hidden" *matCellDef="let element">
                    <mat-icon>more_vert</mat-icon>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"
                    (click)="getTableRecord(row)"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
                </tr>
              </table>

            </div>

            <div class="example-container">
            <mat-paginator [pageSize]="10"
                           [pageSizeOptions]="[5, 10, 25, 100]"
                           showFirstLastButtons></mat-paginator>
            </div>


          </mat-card-content>
        </mat-card>
      </div>
    </div>
    </ng-container>  <!-- end  report_type=attribution_first_click-->

    <ng-container *ngIf="report_type=='attribution_sales' || report_type=='attribution_calls'">

      <div style="margin-left: 20px; width: 900px;">
        <br>
        <mat-form-field appearance="standard">
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="applyFilterAttributionSales($event)" placeholder="Ex. Mia" #input_attribution_sales>
        </mat-form-field>

        <div ngClass="table-width-full" ngClass.xs="table-width-xs" ngClass.sm="table-width-sm">
          <mat-card class="mat-elevation-z24">
            <mat-card-content>

              <div class="example-container mat-elevation-z24">
                <table mat-table [dataSource]="dataSourceAttributionSales" matSort>

                  <!-- Pruchase DTColumn -->
                  <ng-container matColumnDef="purchase_dt" sticky>
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                    <td mat-cell *matCellDef="let row"> {{row.purchase_dt}} </td>
                  </ng-container>

                  <!-- Service Column -->
                  <ng-container matColumnDef="service" sticky>
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Service</th>
                    <td mat-cell *matCellDef="let row"> {{row.service}} </td>
                  </ng-container>


                  <!-- Amount Column -->
                  <ng-container  matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Price</th>
                    <td mat-cell *matCellDef="let row"> {{row.amount | currency}} </td>
                  </ng-container>

                  <!--description-->
                  <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Name</th>
                    <td mat-cell *matCellDef="let row"> {{row.description}} </td>
                  </ng-container>

                  <!--fullName-->
                  <ng-container matColumnDef="fullName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Lead Name</th>
                    <td mat-cell *matCellDef="let row"> {{row.fullName}} </td>
                  </ng-container>

                  <!--emailAddress-->
                  <ng-container matColumnDef="emailAddress">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                    <td mat-cell *matCellDef="let row"> {{row.emailAddress}} </td>
                  </ng-container>

                  <!--phoneNumberStandard-->
                  <ng-container matColumnDef="phoneNumberStandard">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone Number</th>
                    <td mat-cell *matCellDef="let row"> {{row.phoneNumberStandard}} </td>
                  </ng-container>


                  <!-- first_event_dt Column -->
                  <ng-container matColumnDef="first_event_dt">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>First Source Date</th>
                    <td mat-cell *matCellDef="let row"> {{row.first_event_dt}} </td>
                  </ng-container>


                  <!--first_action_id-->
                  <ng-container matColumnDef="first_action_id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>First Click Source</th>
                    <td mat-cell *matCellDef="let row"> {{row.first_action_id}}  </td>
                  </ng-container>

                  <!--first_provider-->
                  <ng-container matColumnDef="first_provider">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>First Provider</th>
                    <td mat-cell *matCellDef="let row"> {{row.first_provider}}  </td>
                  </ng-container>

                  <!--first_adgroup-->
                  <ng-container matColumnDef="first_adgroup">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>First Source</th>
                    <td mat-cell *matCellDef="let row"> {{row.first_adgroup}}  </td>
                  </ng-container>

                  <!-- last_event_dt Column -->
                  <ng-container matColumnDef="last_event_dt">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Source Date</th>
                    <td mat-cell *matCellDef="let row"> {{row.last_event_dt}} </td>
                  </ng-container>

                  <!--last_action_id-->
                  <ng-container matColumnDef="last_action_id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Event</th>
                    <td mat-cell *matCellDef="let row"> {{row.last_action_id}} </td>
                  </ng-container>

                  <!--last_provider-->
                  <ng-container matColumnDef="last_provider">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Provider</th>
                    <td mat-cell *matCellDef="let row"> {{row.last_provider}}  </td>
                  </ng-container>

                  <!--last_adgroup-->
                  <ng-container matColumnDef="last_adgroup">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Click Source</th>
                    <td mat-cell *matCellDef="let row"> {{row.last_adgroup}}  </td>
                  </ng-container>

                  <!-- Star Column -->
                  <ng-container matColumnDef="star" stickyEnd>
                    <th mat-header-cell [hidden]="is_table_column_hidden" *matHeaderCellDef></th>
                    <td mat-cell [hidden]="is_table_column_hidden" *matCellDef="let element">
                      <mat-icon>more_vert</mat-icon>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsAttributionSales"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsAttributionSales;" class="element-row"
                      (click)="getTableRecord(row)"></tr>

                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No data matching the filter "{{input_attribution_sales.value}}"</td>
                  </tr>
                </table>


              </div>
              <div class="example-container">
              <mat-paginator [pageSize]="10"
                             [pageSizeOptions]="[5, 10, 25, 100]"
                             showFirstLastButtons></mat-paginator>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>


    </ng-container>

  <!--</ng-container>-->
</div>
